import React from "react";
import { Checkbox } from "@material-ui/core";
import styles from "./CheckBox.module.css";

function CheckBox({ label, checked, onChange, id, name, ...props }) {
  return (
    <div className={styles.checkbox_container}>
      <div className={styles.checkbox_row}>
        <Checkbox
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          {...props}
        />
        <label htmlFor={id} className={styles.checkbox_description} name={name}>
          {label}
        </label>
      </div>
    </div>
  );
}
export default CheckBox;
